/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
@cc._decorator.executeInEditMode
export default class ChildSorter extends cc.Component
{
    @property
    protected set sortChildrenAZ(value: boolean) { this.sortChildNodes(); }
    protected get sortChildrenAZ(): boolean { return false; }

    /** @hidden */
    protected onLoad(): void
    {
        if (!CC_EDITOR) { this.enabled = false; }
    }

    private sortChildNodes(): void
    {
        if (!this.node || !this.node.children || this.node.children.length < 2) { return; }

        let children: cc.Node[] = this.node.children.slice();
        this.node.removeAllChildren();

        children = children.sort((a, b) => a.name.localeCompare(b.name));
        children.forEach(child => this.node.addChild(child));
    }
}
